import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { auth } from '../firebase';
import Header from './Header';
import Footer from './Footer';
import { Section, Card } from '../components/ui';
import './PlaceholderPage.css';

const DEFAULT_DESCRIPTION =
    'This section is a placeholder for now. The previous tools are temporarily unavailable.';

export function PlaceholderPage({ title, description }) {
    const navigate = useNavigate();

    const handleLogout = async () => {
        await auth.signOut();
        navigate('/');
    };

    return (
        <div className="placeholder-page">
            <Header onLogout={handleLogout} />
            <Section variant="large" className="placeholder-section">
                <Card variant="glass" className="placeholder-card">
                    <h1 className="placeholder-title">{title}</h1>
                    <p className="placeholder-text">{description ?? DEFAULT_DESCRIPTION}</p>
                </Card>
            </Section>
            <Footer />
        </div>
    );
}

export function ClientAdminPlaceholder() {
    const { clientId } = useParams();
    return (
        <PlaceholderPage
            title="Client Admin"
            description={`Placeholder for client "${clientId}". Administration tools will return here in a future update.`}
        />
    );
}

export default PlaceholderPage;
